

import {
    Component,
    OnInit,
  } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
  import { NGXLogger } from "ngx-logger";
import { MessageService } from "primeng/api";
  
  import {
    DynamicDialogConfig,
    DynamicDialogRef,
  } from "primeng/dynamicdialog";
  import { Subject } from "rxjs";
import { PraticaFlowdy2_Firestore } from "src/app/models/praticaFirestore.model";
import { PraticheService } from "src/app/services/pratiche.service";
import { Timestamp } from 'firebase/firestore'; 
import { AppuntamentoFase2 } from "src/app/models/dto/appuntamentoFase2.model";
import { Prontofibra_Firestore } from "src/app/models/prontofibra.firestore.model";
import { ModificaPF } from "src/app/models/dto/modificaPF.model";
import { ProntofibraService } from "src/app/services/prontofibra.service";
  

@Component({
    selector: "component-modifica-data_installazione_router",
    templateUrl: "./dialog-modifica-data_installazione_router.component.html",
    styleUrls: ["../shared.component.css"],
  })
  export class DialogModificaDataInstallazioneRouter implements OnInit {
    protected _onDestroy = new Subject<void>();
    protected prontofibra: Prontofibra_Firestore;
    protected modificaDataInstallazioneRouterForm: FormGroup;
    protected isModificandoDataInstallazioneRouter:boolean = false;
    private dataInstallazioneRouter:Date;
    constructor(
      private logger: NGXLogger,
      public dialogRef: DynamicDialogRef,
      public config: DynamicDialogConfig,
      private formBuilder: FormBuilder,
      private pfService:ProntofibraService,
      private messageService: MessageService,
    ) {
      this.prontofibra            = this.config.data.pratica;
      this.dataInstallazioneRouter    = this.prontofibra.dataInstallazioneRouter ? this.convertFirestoreTimestampToDate(this.prontofibra.dataInstallazioneRouter): null;
      
      this.modificaDataInstallazioneRouterForm = this.formBuilder.group({
        dataInstallazioneRouter:  [ this.dataInstallazioneRouter, [Validators.required]]
      });
      
    }
    ngOnInit() {
    }

    private convertFirestoreTimestampToDate(timestamp: Timestamp): Date {
      return timestamp.toDate();
    }
   
  
    conferma(conferma: boolean) {
      if (!conferma) {
        this.dialogRef.close({ success: false });
      } else {
        this.isModificandoDataInstallazioneRouter = true;
        let pfDaModificare:ModificaPF = new ModificaPF();
        pfDaModificare.dataInstallazioneRouter  = this.modificaDataInstallazioneRouterForm.get('dataInstallazioneRouter').value;;
        this.pfService.modificaDataInstallazione(this.prontofibra.id, pfDaModificare).subscribe( {
          next: (res) => {
            this.isModificandoDataInstallazioneRouter = false;
            this.dialogRef.close({ success: true});
          },  error: (e) => {
            this.isModificandoDataInstallazioneRouter = false;
            this.messageService.add({
              severity: "info",
              summary: "Errore" , life:10000,
                detail: "Errore in fase di modifica della data di installazione del router!",
              });
            this.dialogRef.close({ success: false });
          },
          complete: () => {}
          }
        );
       }
    }
  
  }